import { Routes } from '@angular/router';
import { PartnerPortalLayoutComponent } from '../partner-portal/partner-portal-layout/partner-portal-layout.component';
import { PeerTimingsComponent } from '../peer-portal/peer-timings/peer-timings.component';
import { PeerMeetingsComponent } from '../peer-portal/peer-meetings/peer-meetings.component';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';

export const peerRoutes: Routes = [
  {
    path: 'peer-portal', component: PartnerPortalLayoutComponent,
    data: { portal: 'partner' },
    children: [
      {
        path: '', redirectTo: 'timings', pathMatch: 'full'
      },
      {
        path: 'timings', component: PeerTimingsComponent,
        data: {
          expectedRoles: [UserRole.PeerReviewer, UserRole.Admin],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer-meetings', component: PeerMeetingsComponent,
        data: {
          expectedRoles: [UserRole.PeerReviewer],
        },
        canActivate: [PermissionGuard]
      }
    ]
  }
];

